export default {
  templates: state => state.templates
}
